class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverEnabled = this.dataset.hover === 'true';

    if (this.hoverEnabled) {
      this.setupHover();
    }
  }

  setupHover() {
    let leaveTimer;
    const summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('mouseenter', () => {
      clearTimeout(leaveTimer);
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        this.onToggle();
      }
    });

    this.addEventListener('mouseleave', () => {
      leaveTimer = setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.close();
        }
      }, 250);
    });

    // Keep open when hovering content
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      clearTimeout(leaveTimer);
    });
  }

  onToggle() {
    if (!this.hoverEnabled) {
      // Original animation handling for non-hover menus
      if (!this.animations) this.animations = this.content.getAnimations();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animations.forEach((animation) => animation.play());
      } else {
        this.animations.forEach((animation) => animation.cancel());
      }
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
